// pages/StudentLoginPage.js
import React, { useEffect } from 'react';
import { Box, Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { useStudentAuth } from '../context/StudentAuthContext';
import { useNavigate } from 'react-router-dom';
import { StudentLoginForm } from '../components/forms/StudentLoginForm/StudentLoginForm';
import { LoadingSpinner } from '../components/layout/LoadingSpinner';

import { StudentAuthForm } from "../components/forms/UsersLoginForm/StudentAuthForm";
import { RightElement } from "../components/common/RightElement";

export const StudentLoginPage = () => {
  const imgSrc = "./cat2.png"
  const { isAuthenticated, authLoading } = useStudentAuth();
  const navigate = useNavigate();

  useEffect(() => { 
    // console.log("🔄 StudentLoginPage: isAuthenticated =", isAuthenticated);
    if (isAuthenticated) {
      // console.log("🎯 StudentLoginPage: Redirecting to dashboard");
      navigate('/students-dashboard');
    }
  }, [isAuthenticated, navigate]);

  if (authLoading) {
    return (
      <div className="login-loading-container parentdiv">
        <LoadingSpinner />
        {/* <p>Checking authentication status...</p> */}
      </div>
    );
  }

  return (
     <Container maxWidth="lg" className="parentdiv register-form mb-40">
        <Box>
            <Grid container>
                <Grid item xs={12} md={6} className="login" >
                    <StudentAuthForm />
                    
                    
                </Grid>
                <Grid item xs={12} md={6} >
                    <RightElement imgSrc={imgSrc}/>
                </Grid>

                
            </Grid>
        </Box>

        </Container>
    // <div className="login-page-container">
    //   <StudentLoginForm />
    // </div>
  );
};